<template>
  <div class="pwc-self-update">
    <van-nav-bar
      :title="cTitle"
      left-text="取消"
      right-text="保存"
      fixed
      @click-left="handleReturn"
      @click-right="handleSave"
    />

    <pwc-container>
      <van-cell-group :border="false" class="pwc-self-address">
        <van-field
          v-model="cShow"
          autofocus
          :placeholder="cPlaceholder"
          :readonly="cInputDisabled"
          :is-link="cInputDisabled"
          @click="handleFieldClick"
        />
      </van-cell-group>
    </pwc-container>

    <van-popup v-model="showPicker" position="bottom">
      <van-picker
        value-key="name"
        :columns="cColumns"
        :default-index="cDefaultIndex"
        @change="handlePickerChange"
      />
    </van-popup>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import RouterName from '@/constants/route'
import Actions from '@/constants/action'
import { loading } from '@/mixin'
import { NavBar, CellGroup, Field, Popup, Picker } from 'vant'
import PwcContainer from '@/views/layout/mobile/PwcContainer'

/**
 * tp: 0 input
 *     1 select
 */

/**
 * lookup:
 *  anchorStudentGrades
 *  ageRange
 *  workYearRange
 */
export default {
  components: {
    VanNavBar: NavBar,
    VanCellGroup: CellGroup,
    VanField: Field,
    VanPopup: Popup,
    VanPicker: Picker,
    PwcContainer
  },
  mixins: [loading],
  data() {
    return {
      message: this.$route.query.message || '',
      propName: this.$route.query.prop || 'name',
      type: Number(this.$route.query.type) || 0,
      lookupName: this.$route.query.lookupName || '',
      showPicker: false
    }
  },
  computed: {
    ...mapState(['lookups', 'loading', 'userInfo']),
    cTitle() {
      return `更新${this.$route.query.name}`
    },
    cPlaceholder() {
      if (this.type !== 0) {
        return '请选择'
      } else {
        return '请输入...'
      }
    },
    cInputDisabled() {
      return this.type !== 0
    },
    cColumns() {
      return (this.lookups[this.lookupName]) || []
    },
    cLoading() {
      return this.loading.userInfoLoading
    },
    cDefaultIndex() {
      return (this.lookups[this.lookupName] || []).findIndex(v => v.id === this.message)
    },
    cShow: {
      get() {
        if (this.type === 1) {
          const obj = (this.lookups[this.lookupName] || []).find(v => v.id === this.message)
          if (obj) {
            return obj.name
          }
        }
        return this.message
      },
      set(n) {
        this.message = n
      }
    }
  },
  methods: {
    ...mapActions({
      updateInfo: Actions.UPDATE_USER_INFO
    }),
    handleFieldClick() {
      if (this.type === 1) {
        this.showPicker = true
      }
    },
    handleReturn() {
      this.$router.replace({
        name: this.$route.query.from || RouterName.home
      })
    },
    handleSave() {
      const updated = Object.assign({}, this.userInfo, {
        [this.propName]: this.message
      })
      updated.eventId = ''
      Reflect.deleteProperty(updated, 'profilePhotoUrl')
      this.updateInfo(updated).then(() => {
        this.handleReturn()
      })
    },
    handlePickerChange(i, v) {
      this.message = v.id
      this.showPicker = false
    }
  }
}
</script>

